import currency from 'currency.js';
export const formatCurrency = (amount: number) =>
  currency(amount, {
    fromCents: true,
    symbol: '£',
  }).format();
